import { render, staticRenderFns } from "./InfoTabs.vue?vue&type=template&id=265f860c&scoped=true&"
import script from "./InfoTabs.vue?vue&type=script&lang=js&"
export * from "./InfoTabs.vue?vue&type=script&lang=js&"
import style0 from "./InfoTabs.vue?vue&type=style&index=0&id=265f860c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265f860c",
  null
  
)

export default component.exports